// frontend/src/Home.js
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { FaUser } from 'react-icons/fa';
import { IoMdLogOut } from 'react-icons/io';
import {urlApiProd,formatCurrency,print,formatDDMMYYYY,subtractDaysFromDate} from './utiles';
import moment from 'moment';
import Moment from "react-moment";
import { Modal, Button, Spinner, Badge, Card, Container, Row, Col, Accordion, Alert,Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import GestionCPO from './solicitudesbooking/GestionCPO';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';


function Home() {
  const [dateToFormat, setdateToFormat] = useState(moment().toDate().getTime())
  const [message, setMessage] = useState('');
  const [dolar, setdolar] = useState('');
  const [reales, setreales] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [dataSolicitudes, setDataSolicitudes] = useState([]);
  const [principal, setPrincipal] = useState(undefined);
  const firstRender = useRef(true);
  const [showCPO, setShowCPO] = useState(false);
  const [selectedCPO, setSelectedCPO] = useState(null);
  const [dataPuertos, setDataPuertos] = useState([]);
  const [dataFFW, setDataFFW] = useState([]);
  const [dataCarrier, setDataCarrier] = useState([]);
  const [dataSolicitudesInternas, setDataSolicitudesInternas] = useState([]);
  const [apoyo, setApoyo] = useState(undefined);
  const [dataAlertaColeta,setdataAlertaColeta] = useState([]);
  const [dataAlertaDLC,setdataAlertaDLC] = useState([]);
  const [dataAlertaCrossDocking,setdataAlertaCrossDocking] = useState([]);
  const [dataAlertaMAPA,setdataAlertaMAPA] = useState([]);
  const [dataAlertaAsignacion,setdataAlertaAsignacion] = useState([]);
  const token = localStorage.getItem('token');
  const [showToast, setShowToast] = useState(false);
  const [mensajeToast,setMensajeToast] = useState('Favor verificar correo o contraseña.');

  useEffect(() => {
    if (firstRender.current) {
      setLoading(true);
      fetchData();
      fetchApoyo();
      firstRender.current = false;
  }
    //fetchMessage();
    //fetchDolar();
    //fetchReales();
    //let time = updateTime;
    //setdateToFormat(time);
  }, []);

      const fetchData = async () => {
          const token = localStorage.getItem('token');
          try {
              const response = await fetch(`${urlApiProd}/solicitudesbooking`, {
                  headers: { 'Authorization': `Bearer ${token}` }
              });
              if (!response.ok) throw new Error('Error fetching Solicitudes');
              const data = await response.json();
              setDataSolicitudes(data);
              //setTotalItems(total);
              setPrincipal(true);
              const now = moment();

              data.forEach((book, index)=>{
                if(book.nro_booking!==""){
                  
                if(book.dld!==null && now.isAfter(subtractDaysFromDate(book.dld,4)) && book.alerta_coleta===0){
                  //print(`booking: ${book.dld}`);
                  dataAlertaColeta.push(book);
                }

                if(book.dlc!==null && now.isAfter(subtractDaysFromDate(book.dlc,3)) && book.alerta_dlc===0){
                  //print(`booking: ${book.nro_booking}`);
                  dataAlertaDLC.push(book);
                }

                if(book.dlc!==null && book.cross_docking==='si' && book.alerta_crossdocking===0 && now.isAfter(subtractDaysFromDate(book.dlc,10))){
                  //print(`booking: ${book.nro_booking}`);
                  dataAlertaCrossDocking.push(book);
                }

                if(book.dlc!==null && book.mapa==='si' && book.alerta_mapa===0 && now.isAfter(subtractDaysFromDate(book.dlc,13))){
                  //print(`booking: ${book.nro_booking}`);
                  dataAlertaMAPA.push(book);
                }

                

              }
              });
          } catch (error) {
              console.error('Error fetching data:', error);
              setPrincipal(false);
              toast.error(`Solicitudes no cargadas: ${error.message}`, { toastId: 'error-principal' });
          } finally{ 
            setLoading(false);
          }
      };

          const fetchApoyo = async () => {
              const token = localStorage.getItem('token');
              try {
      
                  fetchApoyoSolicitudesInternas();
      
                  const responses = await Promise.all([
                      fetch(`${urlApiProd}/puertos`, { headers: { 'Authorization': `Bearer ${token}` } }),
                      fetch(`${urlApiProd}/ffw`, { headers: { 'Authorization': `Bearer ${token}` } }),
                      fetch(`${urlApiProd}/carriers`, { headers: { 'Authorization': `Bearer ${token}` } }),
                  ]);
      
                  const [puertos, ffw, carriers,alertas] = await Promise.all(responses.map(res => {
                      if (!res.ok) throw new Error('Error fetching data');
                      return res.json();
                  }));
      
                  puertos.sort((x, y) => {
                      if (x.nombre < y.nombre) return -1;
                      if (x.nombre > y.nombre) return 1;
                      return 0;
                  });
      
                  setDataPuertos(puertos);
                  setDataFFW(ffw);
                  setDataCarrier(carriers);
                  setApoyo(true);
              } catch (error) {
                  console.error('Error en fetchApoyo:', error.message);
                  setApoyo(false);
                  toast.error(`Datos de apoyo no cargados: ${error.message}`, { toastId: 'error-apoyo' });
              }
          };

              const fetchApoyoSolicitudesInternas = async () => {
                  const token = localStorage.getItem('token');
                  try {
                      const responses = await Promise.all([
                          fetch(`${urlApiProd}/solicitudesinternas`, { headers: { 'Authorization': `Bearer ${token}` } }),
                      ]);
          
                      const [solicitudesInternas] = await Promise.all(responses.map(res => {
                          if (!res.ok) throw new Error('Error fetching data');
                          return res.json();
                      }));
          
                      const dataSolint = solicitudesInternas.filter(solicitud => solicitud.estado === 1 && solicitud.cantidad!==solicitud.cantidad_solicitada);
          
                      setDataSolicitudesInternas(dataSolint);
          
                  } catch (error) {
                      console.error('fetchApoyoSolicitudesInternas:', error.message);
                      toast.error(`fetchApoyoSolicitudesInternas: ${error.message}`, { toastId: 'error-apoyo' });
                  }
              };

              const handleCloseCPO = () => {
                setSelectedCPO(null);
                setShowCPO(false);
                fetchData();
            };

        const handleCPO = (solicitud) => {
          setdataAlertaColeta([]);
          setdataAlertaDLC([]);
          setdataAlertaCrossDocking([]);
          setdataAlertaMAPA([]);
        
                print(`solicitud ${JSON.stringify(solicitud)}`);
                setSelectedCPO(solicitud);
                setShowCPO(true);
            };

const updateCheckStatus = async (row,alerta) => {
        print(`updateCheckStatus ${alerta} id_solicitud ${row.id_solicitud}`);

        if(alerta==='alerta_crossdocking'){
        row.alerta_crossdocking = 1;
        } else if(alerta==='alerta_mapa'){
        row.alerta_mapa = 1;
        }
        
try {
            const response = await fetch(`${urlApiProd}/editsolicitudbooking/${row.id_solicitud}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(row)
            });


            if (response.ok){ 

              if(alerta==='alerta_crossdocking'){
                const indx = dataAlertaCrossDocking.findIndex(b => b.id_solicitud===row.id_solicitud);

                if(indx!==-1){
                  dataAlertaCrossDocking.splice(indx, 1); 
                  setdataAlertaCrossDocking( dataAlertaCrossDocking.map((solicitud, currentIndex) =>
                currentIndex === indx
                  ? { ...solicitud, alerta_crossdocking: row.alerta_crossdocking }
                  : solicitud
              ));  
            }
            setMensajeToast(`Alerta Apagada para booking ${row.nro_booking}`);
                setShowToast(true);
              } else if(alerta==='alerta_mapa'){
                const indx = dataAlertaMAPA.findIndex(b => b.id_solicitud===row.id_solicitud);

                if(indx!==-1){
                  dataAlertaMAPA.splice(indx, 1); 
                  setdataAlertaMAPA( dataAlertaMAPA.map((solicitud, currentIndex) =>
                currentIndex === indx
                  ? { ...solicitud, alerta_mapa: row.alerta_mapa }
                  : solicitud
              ));
            }
            setMensajeToast(`Alerta Apagada para booking ${row.nro_booking}`);
                setShowToast(true);
              }
              
            } else{
                alert("No fue posible actualizar");
            }
        } catch (error) {
                console.error('Error:', error);
            }
    }

  const fetchMessage = () => {
    setLoading(true);
    setSuccess(false);
    axios.get(urlApiProd)
      .then(response => {
        setMessage(response.data.message);
        setError(''); // Limpiar cualquier error previo
        setSuccess(true); // Indicar que la solicitud fue exitosa
      })
      .catch(error => {
        if (error.response) {
          // El servidor respondió con un código de estado fuera del rango 2xx
          setError(`Error: ${error.response.status} - ${error.response.data}`);
        } else if (error.request) {
          // La solicitud fue hecha pero no hubo respuesta
          setError('Error: No response received from the server.');
        } else {
          // Algo ocurrió al preparar la solicitud
          setError(`Error: ${error.message}`);
        }
        console.error('There was an error fetching the data!', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchDolar = () => {
    setSuccess(false);
    axios.get("https://cl.dolarapi.com/v1/cotizaciones/usd")
      .then(response => {
        setdolar(response.data.compra);
        setSuccess(true); // Indicar que la solicitud fue exitosa
      })
      .catch(error => {
        if (error.response) {
          // El servidor respondió con un código de estado fuera del rango 2xx
          setError(`Error: ${error.response.status} - ${error.response.data}`);
        } else if (error.request) {
          // La solicitud fue hecha pero no hubo respuesta
          setError('Error: No response received from the server.');
        } else {
          // Algo ocurrió al preparar la solicitud
          setError(`Error: ${error.message}`);
        }
        console.error('There was an error fetching the data!', error);
      });
  };

  const fetchReales = () => {
    setSuccess(false);
    axios.get("https://cl.dolarapi.com/v1/cotizaciones/brl")
      .then(response => {
        setreales(response.data.compra);
        setSuccess(true); // Indicar que la solicitud fue exitosa
      })
      .catch(error => {
        if (error.response) {
          // El servidor respondió con un código de estado fuera del rango 2xx
          setError(`Error: ${error.response.status} - ${error.response.data}`);
        } else if (error.request) {
          // La solicitud fue hecha pero no hubo respuesta
          setError('Error: No response received from the server.');
        } else {
          // Algo ocurrió al preparar la solicitud
          setError(`Error: ${error.message}`);
        }
        console.error('There was an error fetching the data!', error);
      });
  };

  const updateTime = () => {
    let clock = moment().toDate().getTime()
  }
  setInterval(updateTime, 1000)

  return (
    <div className="Home">
        {!loading && message && <p>{message}</p>}
       {/* <Moment interval={1} unit="seconds">
              {dateToFormat}
        </Moment>*/}
        {!loading && dolar && <p>USD{formatCurrency(dolar)}</p>}
        {!loading && dolar && <p>BRL{formatCurrency(reales)}</p>}
      <Card>
      <Card.Img style={{maxHeight:300, objectFit: 'cover'}} variant="top"  src="https://palmtradechile.com/wp-content/uploads/2018/08/1.jpg" /> 
      {localStorage.getItem('RolMenu')==='2' ? (
         <Card.Body>
        <Alert key='primary' variant='primary'>
        Bienvenid@ {localStorage.getItem('Nombre')}
                </Alert>    
        
      <p></p>
      {loading ? (
                                        <div className="text-center">
                                            <Spinner animation="border" role="status" />
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                    ) : (<div>
       <h4>Alertas Gestión de Booking</h4>    
       <p></p>                           
   <Container>
      <Row>
      <Col>
      <Accordion defaultActiveKey="0"> <Accordion.Item eventKey="0">
        <Accordion.Header>Alerta Coleta    <Badge bg="danger" style={{marginLeft: 10}}>
                                                {dataAlertaColeta.length}
                                            </Badge></Accordion.Header>
        <Accordion.Body>
          {dataAlertaColeta.length>0 ? (<Table striped bordered hover>
                                              <tbody>
                                              <tr>
                                              <th>N° Booking</th>
                                              <th>DLD</th>
                                            
                                              </tr>
                                              {dataAlertaColeta.map((object, i) => <tr><td><a href="#" onClick={() => handleCPO(object)}>
                                              {object.nro_booking}
</a></td><td>{formatDDMMYYYY(object.dld)}</td>
                                            
                                                  </tr>)}
          
                                              </tbody>
                                         </Table>) : (<>Sin alertas pendientes</>) }
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      </Col>
        <Col>
        <Accordion defaultActiveKey="0"> <Accordion.Item eventKey="0">
        <Accordion.Header>Alerta DLC    <Badge bg="danger" style={{marginLeft: 10}}>
                                                {dataAlertaDLC.length}
                                            </Badge></Accordion.Header>
        <Accordion.Body>
        {dataAlertaDLC.length>0 ? (<Table striped bordered hover>
                                              <tbody>
                                              <tr>
                                              <th>N° Booking</th>
                                              <th>DLC</th>
                                          
                                              </tr>
                                              {dataAlertaDLC.map((object, i) => <tr><td><a href="#" onClick={() => handleCPO(object)}>
                                              {object.nro_booking}
</a></td><td>{formatDDMMYYYY(object.dlc)}</td>
                                            
                                                  </tr>)}
          
                                              </tbody>
                                         </Table>) : (<>Sin alertas pendientes</>) }
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      </Col>
      <Col>
        <Accordion defaultActiveKey="0"> <Accordion.Item eventKey="0">
        <Accordion.Header>Alerta Asignación    <Badge bg="danger" style={{marginLeft: 10}}>
                                                {dataAlertaAsignacion.length}
                                            </Badge></Accordion.Header>
        <Accordion.Body>
        {dataAlertaAsignacion.length>0 ? (<Table striped bordered hover>
                                              <tbody>
                                              <tr>
                                              <th>N° Booking</th>
                                              <th>DLC</th>
                                          
                                              </tr>
                                              {dataAlertaAsignacion.map((object, i) => <tr><td><a href="#" onClick={() => handleCPO(object)}>
                                              {object.nro_booking}
</a></td><td>{formatDDMMYYYY(object.dlc)}</td>
                                            
                                                  </tr>)}
          
                                              </tbody>
                                         </Table>) : (<>Sin alertas pendientes</>) }
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      </Col>
      </Row>
      <p></p>
      <Row>
        <Col>
        <Accordion defaultActiveKey="0"> <Accordion.Item eventKey="0">
        <Accordion.Header>Alerta Cross Docking    <Badge bg="danger" style={{marginLeft: 10}}>
                                                {dataAlertaCrossDocking.length}
                                            </Badge></Accordion.Header>
        <Accordion.Body>
        {dataAlertaCrossDocking.length>0 ? (<Table striped bordered hover>
                                              <tbody>
                                              <tr>
                                              <th>N° Booking</th>
                                              <th>Acción</th>
                                              </tr>
                                              {dataAlertaCrossDocking.map((object, i) => <tr><td><a href="#" onClick={() => handleCPO(object)}>
                                              {object.nro_booking}
</a></td>
                                              <td>
                                              <Button variant="outline-primary" size="sm" onClick={() => {
                                                if(window.confirm('¿Estás seguro de apagar alarma?'))
                                                updateCheckStatus(object,"alerta_crossdocking");}}>
                                          Apagar
                                      </Button>
                                              </td>
                                                  </tr>)}
          
                                              </tbody>
                                         </Table>) : (<>Sin alertas pendientes</>) }
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
        </Col>
        <Col>
        <Accordion defaultActiveKey="0"> <Accordion.Item eventKey="0">
        <Accordion.Header>Alerta MAPA    <Badge bg="danger" style={{marginLeft: 10}}>
                                                {dataAlertaMAPA.length}
                                            </Badge></Accordion.Header>
        <Accordion.Body>
        {dataAlertaMAPA.length>0 ? (<Table striped bordered hover>
                                              <tbody>
                                              <tr>
                                              <th>N° Booking</th>
                                              <th>Acción</th>
                                              </tr>
                                              {dataAlertaMAPA.map((object, i) => <tr><td><a href="#" onClick={() => handleCPO(object)}>
                                              {object.nro_booking}
</a></td>
                                              <td>
                                              <Button variant="outline-primary" size="sm" onClick={() => 
                                                {
                                                  if(window.confirm('¿Estás seguro de apagar alarma?'))
                                                  updateCheckStatus(object,"alerta_mapa");}}>
                                          Apagar
                                      </Button>
                                              </td>
                                                  </tr>)}
          
                                              </tbody>
                                         </Table>) : (<>Sin alertas pendientes</>) }
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
        </Col>
      </Row>
    </Container>
                                      </div>)}

      </Card.Body>
      ) : (<Card.Body>
        <Alert key='primary' variant='primary'>
        Bienvenid@ {localStorage.getItem('Nombre')}
                </Alert>   </Card.Body> )}
    </Card>
    <ToastContainer
              className="p-3"
              position='top-center'
              style={{ zIndex: 1, maxWidth: 'unset' }}
            >
                  <Toast style={{width: '35vw'}} onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
                    <Toast.Header>
                      <img
                        src="holder.js/20x20?text=%20"
                        className="rounded me-auto"
                        alt=""
                      />
                      <strong className="me-auto">Mensaje del sistema</strong>
                    </Toast.Header>
                    <Toast.Body className="text-center">{mensajeToast}</Toast.Body>
                  </Toast>
                  </ToastContainer>
    {selectedCPO && showCPO && <GestionCPO desde={'bookingexterno'} solicitud={selectedCPO} puertos={dataPuertos} ffw={dataFFW} carriers={dataCarrier} solicitudesInternas={dataSolicitudesInternas} cerrar={handleCloseCPO} />}
    </div>
  );
}

export default Home;
